const t = {
  "tooltip-content": "tooltip-content",
  "tooltip-content--open": "tooltip-content--open",
  "tooltip-content__text": "tooltip-content__text",
  "tooltip-content__arrow": "tooltip-content__arrow"
};
export {
  t as default
};
